import React, { Component } from "react";
import { Segment, Dimmer, Loader } from "semantic-ui-react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import * as PostActions from "./postActions";
import { Common } from "../../../utils";

class Post extends Component {
  componentDidMount() {
    const {
      location: { state },
      postActions
    } = this.props;
    if (state !== undefined) {
      postActions.onGetSpecificBookmark(state.bookmarkId);
    } else {
      const path = window.location.pathname.split("/");
      var id = path[path.length - 2];
      postActions.onGetSpecificBookmark(id);
    }
  }

  onHandleLike(id, isLoggedIn) {
    if (!isLoggedIn) {
      Common.showInfoMessage("Login to like this bookmark");
      return;
    }
    const { postActions } = this.props;
    postActions.likeUp(id);
  }

  render() {
    const { isLoading, specificBookmark, isLoggedIn, likes } = this.props;
    return (
      <div style={{ width: "100%", marginTop: "10px" }}>
        <Segment color="green" style={{ wordWrap: "break-word", height: 150 }}>
          <Dimmer.Dimmable dimmed={isLoading}>
            <Dimmer active={isLoading} inverted={true}>
              <Loader>Loading</Loader>
            </Dimmer>
            <div style={{ width: "100%", height: 40 }}>
              <span style={{ fontSize: 25 }}>
                <a href={specificBookmark.URL} rel="dofollow">
                  {specificBookmark.StoryTitle}
                </a>
              </span>
            </div>
            <div style={{ width: "100%", height: 40 }}>
              <span style={{ fontSize: 18 }}>
                {specificBookmark.Description !== undefined && specificBookmark.Description !==null ? specificBookmark.Description: specificBookmark.Descriptions !== undefined && specificBookmark.Descriptions.length >=1 ? specificBookmark.Descriptions[0].Description : '' }
              </span>
            </div>
            <div style={{ width: "100%", height: 50 }}>
              <div style={{ float: "left", paddingTop: "22px" }}>
                {specificBookmark.CategoryName}
              </div>
              <div style={{ float: "Right", display: "inline-flex" }}>
                <div style={{ paddingTop: "5%", paddingRight: "18px" }}>
                  <i class="eye icon"></i>
                  {specificBookmark.Views}
                </div>

                <div
                  class="ui labeled button"
                  tabindex="0"
                  onClick={() =>
                    this.onHandleLike(specificBookmark.Id, isLoggedIn)
                  }
                >
                  <div class="ui red button">
                    <i class="heart icon"></i> Like
                  </div>
                  <a class="ui basic red left pointing label">
                    {likes == null ? 0 : likes}
                  </a>
                </div>
              </div>
            </div>
          </Dimmer.Dimmable>
        </Segment>
      </div>
    );
  }
}

const mapStateToProps = ({ post }) => {
  const { isLoading, specificBookmark, likes } = post;
  return {
    isLoading,
    specificBookmark,
    likes
  };
};

const mapDispatchToProps = dispatch => {
  return {
    postActions: bindActionCreators(PostActions, dispatch)
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Post));
